/**
 * The end-user Buntu Companion portal is served by this same SPA bundle but is
 * a separate surface from the admin Hub: no sidebar, no admin navigation.
 *
 * The desktop tray loads this URL, so the path is part of the product contract
 * and must not change without updating the companion host.
 */
export const COMPANION_PORTAL_PATH = '/companion';

/**
 * CRA builds with relative asset URLs (package.json "homepage": "."), so the
 * bundle only resolves at the exact path. serve-with-proxy.js redirects the
 * trailing-slash form here, and this matcher stays lenient so the portal still
 * renders if a client reaches it another way.
 */
export function isCompanionPortalPath(pathname: string | null | undefined): boolean {
  const clean = (pathname || '').replace(/\/+$/, '').toLowerCase();
  return clean === COMPANION_PORTAL_PATH;
}
